<template>
    <DCard
        padding
    >
        <div class="mb-5">
            <h4>
                {{ template.brand_id === null ? __('tools.emails.editor.default') : template.brand.name }} - {{ __(`tools.emails.email.${template.name}.name`) }}
            </h4>
            <span class="text-muted fst-italic">
                {{ __(`tools.emails.email.${template.name}.description`) }}
            </span>
        </div>
        <DForm @submit.prevent>
            <div class="code-textarea-container">
                <DRow>
                    <DCol col="7">
                        <DFormRow
                            class="mb-4"
                            is-vertical
                            :label="__('tools.emails.editor.brand')"
                            is-required
                            :error="validationErrors['brand']"
                        >
                            <DSelect
                                v-model="form.brand"
                                disabled
                                :options="brandOptions"
                            />
                        </DFormRow>
                        <DFormRow
                            class="mb-4"
                            is-vertical
                            :label="__('tools.emails.editor.subject')"
                            is-required
                            :error="validationErrors['template.subject']"
                        >
                            <DFormTextarea
                                v-model="form.subject"
                                rows="5"
                            />
                        </DFormRow>
                        <PreviewText
                            :content="form.subject"
                            :email-type="template.name"
                            :sample="sample"
                        />
                        <DFormRow
                            class="mb-4"
                            is-vertical
                            :label="__('tools.emails.editor.preheader_text')"
                            is-required
                            :error="validationErrors['template.preheader_text']"
                        >
                            <DFormTextarea
                                v-model="form.preheader_text"
                                rows="5"
                            />
                        </DFormRow>
                        <PreviewText
                            :content="form.preheader_text"
                            :email-type="template.name"
                            :sample="sample"
                        />
                        <DFormRow
                            class="mb-4"
                            is-vertical
                            :label="__('tools.emails.editor.content')"
                            is-required
                            :error="validationErrors['template.content']"
                        >
                            <DFormTextarea
                                v-model="form.content"
                                rows="15"
                            />
                        </DFormRow>
                        <PreviewText
                            :content="form.content"
                            :email-type="template.name"
                            :sample="sample"
                        />
                        <DFormRow
                            class="mb-4"
                            is-vertical
                            :label="__('tools.emails.editor.links')"
                            :error="validationErrors['links']"
                        >
                            <DSelect
                                v-model="form.links"
                                :options="links"
                                :model-value="selectedLink"
                                @update:modelValue="updateSelectedLink"
                            />
                        </DFormRow>
                    </DCol>
                    <DCol col="5">
                        <h2 class="h5">
                            {{ __('tools.emails.footer_legal_info.legend') }}
                        </h2>
                        <EmailPlaceholders :placeholders="placeholders" />
                    </DCol>
                </DRow>
            </div>
        </DForm>
        <DFabs>
            <DFab
                id="btn-save"
                icon="eye"
                :label="__('messages.preview')"
                @click="handlePreview"
            />
        </DFabs>
        <EmailEditPreviewModal
            :show-modal="showModal"
            :brands="brands"
            :email-type="template.name"
            :mailables="getMailables"
            :preview-route="previewRoute"
            :content-update-route="contentUpdateRoute"
            :form="form"
            @closeModal="closeModal"
            @modalError="handleModalError"
        />
    </DCard>
</template>

<script>

import PreviewText from '~@/Components/Tools/Emails/PreviewText'
import EmailPlaceholders from '~@/Components/Tools/Emails/Placeholders'
import EmailEditPreviewModal from '~@/Components/Tools/Emails/EmailEditPreviewModal'

export default {
    name: 'EmailEditor',
    components: { EmailPlaceholders, PreviewText, EmailEditPreviewModal },
    props: {
        placeholders: {
            type: Object,
            default: () => { return {} }
        },
        template: {
            type: Object,
            default: () => { return {} }
        },
        errors: {
            type: Object,
            default: () => { return {} }
        },
        brands: {
            type: Array,
            default: () => { return [] }
        },
        samples: {
            type: Array,
            default: () => { return [] }
        },
        links: {
            type: Array,
            default: () => { return [] }
        },
        availableLanguages: {
            type: Array,
            default: () => { return [] }
        }
    },
    data () {
        return {
            previewContent: null,
            sample: this.samples[0] ?? null,
            form: this.$inertia.form({
                brand: this.template.brand_id,
                subject: this.template.subject,
                content: this.template.content,
                preheader_text: this.template.preheader_text,
                emailType: this.template.name,
                links: this.template.links,
                language_code: this.template.language_code
            }),
            validationErrors: this.errors,
            showModal: false,
            previewRoute: this.$route('tools.emails.editor.preview'),
            contentUpdateRoute: this.$route('tools.emails.editor.update', { mailTemplate: this.template.name }),
            selectedLink: this.template.links
        }
    },
    computed: {
        getMailables () {
            return [
                {
                    type: this.template.name,
                    samples: this.samples
                }
            ]
        },
        brandOptions  () {
            const options = this.brands.map((brand) => {
                return {
                    label: brand.name,
                    value: brand.id
                }
            })

            options.unshift({
                label: '',
                value: null,
                disabled: true,
                hidden: true,
                selected: true
            })

            return options
        }
    },
    methods: {
        handlePreview () {
            this.showModal = true
            this.validationErrors = this.errors
        },
        closeModal () {
            this.showModal = false
        },
        handleModalError (errorObject) {
            Object.keys(errorObject).forEach((field) => {
                errorObject[field].forEach((message) => {
                    this.validationErrors[field] = message
                })
            })
        },
        updateSelectedLink (value) {
            this.selectedLink = value
        }
    }
}
</script>
